// import React, { Component } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';


// class Webadslider extends Component {
//     constructor(props) {
//         super(props);
        
//         this.adImages = [
//             require('../assets/images/website/Frame 6.png'),
//             require('../assets/images/website/Frame 7.png'),
//             require('../assets/images/website/Frame 8.png'),
//         ];

//         this.owlOptions = {
//             items: 3, 
//             autoplay: true,
//             autoplayTimeout: 5000,
//             loop: true,
//             margin: 20,
//             responsive: {
//                 0: {
//                     items: 1,
//                 },
//                 600: {
//                     items: 2,
//                 },
//                 1000: {
//                     items: 3,
//                 },
//             },
//         };
//     }

//     render() {
//         return (
//             <div className='container-90'>
//             <div className='ps-lg-5 ps-2'>
               

//                 <OwlCarousel className="owl-theme" {...this.owlOptions}>
//                     {this.adImages.map((image, index) => (
//                         <div key={index} className="item2">
//                             <div className="">
//                                 <div className="row">
//                                     <div className="">
//                                         <img src={image} alt={`Advertisement ${index + 6}`}/>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </OwlCarousel>
//             </div>
//             </div>
//         );
//     }
// }

// export default Webadslider;

import React, { Component } from 'react';


// Image paths
import issue1 from '../assets/images/website/Banner1.png';
import issue2 from '../assets/images/website/Banner2.png';
// import issue3 from '../assets/images/website/246.jpg';
import issue4 from '../assets/images/website/Banner3.png';
// import issue5 from '../assets/images/banner5.jpg';

class LogoSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0
        };

        this.logos = [
            issue1,
            issue2,
            // issue3,
            issue4
            // issue5
        ];
    }

    componentDidMount() {
        this.interval = setInterval(this.nextSlide, 5000); // Change image every 5 seconds
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    nextSlide = () => {
        this.setState({
            currentIndex: (this.state.currentIndex + 1) % this.logos.length
        });
    };

    render() {
        const { currentIndex } = this.state;
        const currentImage = this.logos[currentIndex];

        return (
          <div className='container-90'>
            <div className="slider2">
                <div className="slider-image2">
                    <img src={currentImage} alt={`Slide ${currentIndex}`} className="" />
                </div>
            </div>
            </div>
        );
    }
}

export default LogoSlider;






// import React, { Component } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';


// class Webadslider extends Component {
//     constructor(props) {
//         super(props);
//         this.adImages = [
//             {
//                 src: require('../assets/images/ad1.png'),
//                 country: 'India',
//             },
//             {
//                 src: require('../assets/images/logo.png'),
//                 country: 'USA',
//             },
//             {
//                 src: require('../assets/images/ad1.png'),
//                 country: 'India',
//             },
//             {
//                 src: require('../assets/images/logo.png'),
//                 country: 'USA',
//             },
//             {
//                 src: require('../assets/images/ad1.png'),
//                 country: 'India',
//             },
            
//         ];

//         this.owlOptions = {
//             items: 5, // Show 5 items at a time
//             autoplay: true,
//             autoplayTimeout: 5000,
//             loop: true,
//             margin: 20,
//             responsive: {
//                 0: {
//                     items: 1,
//                 },
//                 600: {
//                     items: 2,
//                 },
//                 1000: {
//                     items: 5, // Show 5 items on larger screens
//                 },
//             },
//         };
//     }

//     render() {
//         return (
//             <div className='container-90'>
//                 <div className='ps-lg-5 ps-2'>
//                     <OwlCarousel className="owl-theme" {...this.owlOptions}>
//                         {this.adImages.map((ad, index) => (
//                             <div key={index} className="item2">
//                                 <div className="ad-content">
//                                     <img src={ad.src} alt={`Advertisement ${index + 1}`} />
//                                     <div className="ad-info">
//                                         <h4>{ad.country}</h4>
//                                     </div>
//                                 </div>
//                             </div>
//                         ))}
//                     </OwlCarousel>
//                 </div>
//             </div>
//         );
//     }
// }

// export default Webadslider;